import { render, staticRenderFns } from "./PedencyFieldDetailsModal.vue?vue&type=template&id=5460c54c"
import script from "./PedencyFieldDetailsModal.vue?vue&type=script&lang=js"
export * from "./PedencyFieldDetailsModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports